import { useEffect, useRef, useState } from "react";
import { EmailIcon, EmailShareButton } from "react-share";
import Strings from "../../../../resources/Strings";
import { getReceiptUrls } from "../../../../utils/MenuUtils";
import classes from "./ShareButtons.module.css";

const Email = (props) => {
  const [url, setUrl] = useState("none");
  const shareButton = useRef(null);
  const messageTemplpate = "";
  const onShareClick = async () => {
    if (url === "none") {
      const selectedInvoiceSummaries = props.getSelectedValues(props.parkingHistoryId);
      let message = await getReceiptUrls(selectedInvoiceSummaries);
      setUrl(getEmailTemplate(message));
    }
  };

  const getEmailTemplate = (message) => {
    return Strings.TEMPLATES.RECEIPT_EMAIL.format(
      props?.siteName,
      message,
      props?.userName
    );
  };

  useEffect(() => {
    if (url && url !== "none") {
      shareButton.current?.click();
      setUrl("none");
    }
  }, [url, shareButton]);

  return (
    <EmailShareButton
      className={classes.shareButton}
      url={url}
      ref={shareButton}
      openShareDialogOnClick={url !== "none"}
      title="Email Share"
      onClick={onShareClick}
    >
      <EmailIcon size={32} round={true} />
    </EmailShareButton>
  );
};

export default Email;
